import { FIELD_SIZE, INPUT_FIELD_TYPE } from '@components/DynamicFormField/constant';


export const ON_HOLD_TXN_ACTION_OPTIONS = [
  {
    key: 'FAIL',
    value: 'FAIL',
    label: 'FAIL',
    isDisabled: false
  },
  {
    key: 'QUEUE',
    value: 'QUEUE',
    label: 'QUEUE',
    isDisabled: false
  },
]

export const OnHoldTransactionUpdateModal = [
  {
    key: 'action',
    name: 'action',
    value: null,
    label: 'Action',
    caption: null,
    placeholder: 'Select an Action',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    fieldSize: FIELD_SIZE.MEDIUM,
    options: ON_HOLD_TXN_ACTION_OPTIONS?.map((option) => ({
      value: option.value,
      key: option.key,
      label: option.label,
      isDisabled: option.isDisabled
    })),
    isEditable: true,
    isRequired: true
  }
];
